module.exports = __webpack_public_path__ + "static/media/DSC_0121-2.79468c91.jpg";